export default {
  fr: {
    translation: {
      login: {
        password: 'Mot de passe',
        signIn: 'Enter',
        username: "Code d'utilisateur"
      },
      reset: {
        email: "Adresse de courriel",
        emailMessage: 'Veuillez saisir votre adresse de courriel ci-dessous et nous vous enverrons un lien de réinitialisation.',
        emailMessageError: "L'adresse e-mail est introuvable. Veuillez contacter le service client pour obtenir de l'aide.",
        submitRequest: 'Envoyer la demande',
        title: 'Voici les requis pour votre nouveau mot de passe:',
        emailSent: "Si l'adresse existe dans notre système, nous enverrons le courriel de réinitialisation à cette adresse. Si vous ne retrouvez pas le message dans votre boite de réception, vérifiez votre dossier de pourriels.",
        minlength: 'Votre mot de passe doit contenir au moins 8 caractères',
        case: 'Inclure au moins une lettre minuscule et une majuscule',
        number: 'Inclure au moins un chiffre',
        resetPassword: 'Réinitialiser le mot de passe',
        password: 'Mot de passe',
        confirmPassword: 'Confirmez le mot de passe',
        returnApplication: "Revenir à l'application"
      },
      change: {
        oldPassword: 'Mot de passe actuel',
        newPassword: 'Nouveau mot de passe',
        confirmPassword: 'Confirmer le nouveau mot de passe',
        changePassword: 'Changer le mot de passe',
        success: "Mot de passe modifié avec succès. Cliquez le lien ci-dessous pour revenir à l’application."
      },
      error: {
        unknown: 'Une erreur inconnue est survenue. Veuillez contacter le support.',
        internalError: "Une erreur interne s'est produite. Veuillez contacter le support pour obtenir de l'aide.",
        networkError: "Une erreur interne s'est produite. Veuillez contacter le support pour obtenir de l'aide.",
        invalidCredentials: "Nom d'utilisateur de mot de passe invalide",
        NOT_COMPLEX: 'Le mot de passe ne rempli pas  les requis di complexité.',
        SAME_AS_RECENT: 'Le mot de passe a été utilisé récemment. Veuillez choisir un autre mot de passe.',
        EXPIRED_HASH: "Le lien pour réinitialiser le mot de passe a expiré. Veuillez demander un nouveau lien ou contacter le support technique pour obtenir de l'aide.",
        INACTIVE_ACCOUNT: 'Le compte est actuellement désactivé. Veuillez contacter le support technique pour réactiver votre compte.',
        '404': '404 - Page non trouvée',
        '404Message': 'La page que vous recherchez est introuvable',
        '404Description': "La page que vous recherchez n'existe pas. Il a peut-être été déplacé ou supprimé complètement. Vous pouvez peut-être revenir à la page d’accueil du site et voir si vous pouvez trouver ce que vous recherchez."
      }
    }
  }
}